import * as Rpc from "./rpc";

export const listBusinessUnits = async () => {
  const response = await Rpc.listBusinessUnits({ fields: ["id", "name"] });

  if (response.success) {
    return response.data;
  } else {
    console.error(response.errors);

    throw new Error("Error while fetching Business Units");
  }
};
